/**
 * 占位样片池（风格卡、数字人卡、落地页展示卡共用）。
 * 引擎接通后换成每个模板/avatar 的真实成片，这里只是保证视觉一致的兜底。
 */
export const SAMPLE_VIDEO_POOL = [
  "https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/720/Big_Buck_Bunny_720_10s_1MB.mp4",
  "https://test-videos.co.uk/vids/jellyfish/mp4/h264/720/Jellyfish_720_10s_1MB.mp4",
  "https://test-videos.co.uk/vids/sintel/mp4/h264/720/Sintel_720_10s_1MB.mp4",
  "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/friday.mp4",
  "https://mdn.github.io/learning-area/html/multimedia-and-embedding/video-and-audio-content/rabbit320.mp4",
];

/** 按 id 稳定取样，同一 id 永远拿到同一条（避免每次渲染换片） */
export function pickSampleVideo(id: string): string {
  let h = 0;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return SAMPLE_VIDEO_POOL[h % SAMPLE_VIDEO_POOL.length];
}
